import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Container from "@material-ui/core/Container";
import { Typography, Grid } from "@material-ui/core";
import { colorPrimary } from "../../Constants/theme";

const useStyles = makeStyles({
    mainTitle: {
        marginTop: "40vh",
        marginBottom: 50,
        fontSize: 120,
        color: colorPrimary
    },
    additionalTitle: {
        fontSize: 30,
        color: colorPrimary
    }
});

const Page404 = () => {
    const classes = useStyles();
    return (
        <Container maxWidth="sm">
            <Grid container justify="center" direction="column" alignItems="center">
                <Typography className={classes.mainTitle}>404</Typography>
                <Typography className={classes.additionalTitle}>Page does not exist.</Typography>
            </Grid>
        </Container>
    );
};

export default Page404;
